import Button from "@template/components/Button";
import PropTypes from "prop-types";

const JoinButton = ({ children, href }) => {
  return (
    <Button href={href} theme="violet">
      {children}
    </Button>
  );
};

JoinButton.propTypes = {
  children: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired
};

export default JoinButton;
